<template>
  <div class="d-flex justify-content-end">
    <!-- CANCEL -->
    <base-button @click="sendCloseEvent" type="secondary" size="sm">{{
      $t('knowledge.modals.notifications.cancel')
    }}</base-button>
    <!-- PREVIOUS -->
    <base-button
      v-if="currentStep > 0"
      @click="sendGoToPreviousStepEvent"
      type="primary"
      outline
      size="sm"
      >{{ $t('knowledge.modals.notifications.previous') }}</base-button
    >
    <!-- NEXT -->
    <base-button
      v-if="currentStep !== stepCount - 1"
      @click="sendGoToNextStep"
      type="primary"
      size="sm"
      :disabled="isNextActionDisabled"
      >{{ $t('knowledge.modals.notifications.next') }}</base-button
    >
    <!-- SUBMIT -->
    <base-button
      v-else
      @click="sendContributionEvent"
      type="primary"
      size="sm"
      >{{ $t('knowledge.product.notification.send') }}</base-button
    >
  </div>
</template>

<script>
export default {
  name: 'contribution-modal-actions',
  props: {
    stepCount: Number,
    currentStep: Number,
    isMessageInvalid: Boolean,
    isKnowledgeInvalid: Boolean,
    isRoleIdsInvalid: Boolean,
  },
  methods: {
    sendCloseEvent() {
      this.$emit('close');
    },
    sendGoToPreviousStepEvent() {
      this.$emit('go-to-previous-step');
    },
    sendGoToNextStep() {
      this.$emit('go-to-next-step');
    },
    sendContributionEvent() {
      this.$emit('send-contribution');
    },
  },
  computed: {
    isNextActionDisabled() {
      switch (this.currentStep) {
        case 0:
          return this.isMessageInvalid;
        case 1:
          return this.isKnowledgeInvalid;
        case 2:
          return this.isRoleIdsInvalid;
        default:
          return true;
      }
    },
  },
};
</script>
